import { Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import { Button, SecondaryLink } from "ds/Button";
import { Item, Content } from "ds/Dropdown";

const listItemStyles = css`
  width: 100%;
  justify-content: start;
  font-weight: 400;
  font-size: 14px;
  color: var(--mode-text-neutral-default-weak);
  min-width: fit-content;

  &:hover {
    background-color: var(
      --menu-item-color-primary-100-background-color,
      var(--color-primary-100)
    );
  }

  margin-left: 0px;
  margin-bottom: 0px;
`;

export const ListItem = styled(SecondaryLink)`
  ${listItemStyles}

  & ::after {
    height: 0;
  }
`;

export const ListButton = styled(Button)`
  ${listItemStyles}
`;

export const DropdownCopyItem = styled(Item)`
  justify-content: flex-start;
`;

export const HeaderText = styled(Typography.BodyText)`
  margin-left: 11px;
`;

export const MenuSeparator = styled.hr`
  background: var(--role-bg-neutral-weaker, var(--periwinkle-grey));
  padding-left: 2px;
`;

export const Icon = styled.div`
  display: flex;
  margin-right: 4px;
`;

export const ContainerContent = styled(Content)`
  min-width: 242px;
  display: flex;
  flex-direction: column;

  .copy-project-id {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 12px;

    span {
      margin-left: 8px;
    }
  }
`;
